// extracted by mini-css-extract-plugin
export default {"thankYouContainer":"ThankYou_thankYouContainer__aWJql","box":"ThankYou_box__2DDCt"};